// extracted by mini-css-extract-plugin
export default {"MessageOnboarding":"MessageAucunePrestation_MessageOnboarding__vIQhM","Illustration":"MessageAucunePrestation_Illustration__rV9Zp"};